import { TYPES_SHOP } from "../mutationTypes";
import CouponApi from "../../api/coupon";

export const state = {
    coupon: {},
    uiFlags: {
        isFetching: false,
        // isCreating: false,
        // isUpdating: false,
        // isDeleting: false,
    },
}

export const getters = {
    getUiFlags($state){
        return $state.uiFlags;
    },
    getCoupon($state){
        return $state.coupon;
    },
}

export const actions = {
    clearCoupon: async({commit},payload)=>{
        try {
            commit(TYPES_SHOP.SET_COUPON,{});
        } catch (error) {
            throw error;
        }
    },
    getCoupon: async({commit},payload)=>{
        commit(TYPES_SHOP.SET_COUPON_UIFLAG,{isFetching:true})
        try {
            const {data} = await CouponApi.applyCoupon(payload);
            commit(TYPES_SHOP.SET_COUPON,data||{})
            commit(TYPES_SHOP.SET_COUPON_UIFLAG,{isFetching:false})
            return data||{};
        } catch (error) {
            commit(TYPES_SHOP.SET_COUPON_UIFLAG,{isFetching:false})
            throw error;
        }
    },

};

export const mutations = {
    [TYPES_SHOP.SET_COUPON_UIFLAG](_state,data){
        _state.uiFlags = {
            ..._state.uiFlags,
            ...data,
        }
    },
    [TYPES_SHOP.SET_COUPON](_state,data){
        _state.coupon = data;
    },


};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}